import type { FieldComponentProps } from '../fieldRegistry';
import { AddressSelector } from '../AddressSelector';

/**
 * AddressField component that wraps AddressSelector to conform to the field registry interface
 * 
 * @template T - Must extend string since address fields store address IDs
 */
export function AddressField<T extends string = string>({
  value,
  onChange,
  onBlur,
  disabled,
  placeholder,
}: FieldComponentProps<T>) {
  // Validate and safely convert value to string
  const addressValue = typeof value === 'string' ? value : '';
  
  const handleChange = (addressId: string | undefined) => {
    // Safe conversion with proper type constraint
    const newValue = (addressId || '') as T;
    onChange(newValue);
    onBlur();
  };

  return (
    <AddressSelector
      value={addressValue}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
}